import * as yup from 'yup';
import { Util } from '../../lib/util';

export interface ISignUpSchema {
  name: string;
  email: string;
  'bot-field': string;
}

export const signUpSchema = yup.object().shape({
  name: yup.string(),
  email: yup
    .string()
    .required('Please enter an email')
    .test('valid-email', 'Invalid Email', Util.validateEmail),
});

export const signUpInitialValues: ISignUpSchema = {
  name: '',
  email: '',
  'bot-field': '',
};
